<div class="fx-bonus-top-loss-history card bg-dark-lighter text-white">
  <div class="card-header ">
    {{ 'Top 5 Loss Cut' | uppercase }}
  </div>
  <div class="card-body" id="lossCutTransaction">
    <div class="p-15">
      <div class="row mb-15">
        <div class="col-md-6">
          <div
            class="input-group search-group"
            [ngClass]="{ loading: loading }"
          >
            <input
              type="text"
              class="form-control bg-dark"
              name="keyword"
              [(ngModel)]="condition.keyword"
              placeholder="Search email"/>
            <div class="input-group-append">
              <button
                class="btn btn-main"
                type="button"
                (click)="searchLossCutTransaction()"
              >
                Search
              </button>
              <button
                class="btn btn-main ml-2"
                type="button"
                (click)="onRefresh()"
              >
                Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <form class="form" name="form">
              <table class="rox-table table-bordered bg-dark">
                <thead>
                <tr>
                  <th>No</th>
                  <th class="text-center">Email</th>
                  <th class="text-center">Account</th>
                  <th class="text-center">IB In Change</th>
                  <th class="text-center">Current Balance</th>
                  <th class="text-center">Current Bonus</th>
                  <th class="text-center"></th>
                </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor=" let item of data">
                    <td class="text-center">{{item.loss_cut_id}}</td>
                    <td class="text-center">{{item.email}}</td>
                    <td class="text-center">{{item.account}}</td>
                    <td class="text-center">{{item.ib_change}}</td>
                    <td class="text-center">{{item.current_balance}}</td>
                    <td class="text-center">{{item.current_bonus}}</td>
                    <td class="text-center action-change-amount">
                      <button class="btn btn-mainuce" type="button"
                              data-bs-toggle="modal" data-bs-target="#modalChangeAmountTopLoss" (click)="onChangeAmountTopLoss('reduce')">-</button>
                      <button class="btn btn-add" type="button"
                              data-bs-toggle="modal" data-bs-target="#modalChangeAmountTopLoss" (click)="onChangeAmountTopLoss('add')">+</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </form>
          </div>
        </div>
      </div>
      <div class="row mt-15">
        <div class="col">
          <div class="pagination-wrapper"></div>
        </div>
      </div>
    </div>
  </div>
  <!-- CHANGE AMOUNT MODAL TOP LOSS -->
  <div class="modal fade fx-modal" id="modalChangeAmountTopLoss" #modalUser>
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">
            {{(addChangeModeTopLoss) ? 'Add' : 'Reduce'}} Amount Loss Cut
          </h4>
          <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form class="form form-horizontal" #form="ngForm" autocomplete="off">
            <div class="row">
              <mat-form-field appearance="fill" floatLabel="auto">
                <mat-label>Amount</mat-label>
                <input
                  matInput
                  type="number"
                  placeholder="ex: 10"
                  name="txtAmountTopLoss"
                  [(ngModel)]="valueAmountTopLoss"
                  #txtAmountTopLoss="ngModel"
                  required
                />
                <span matSuffix>{{currency}}</span>
              </mat-form-field>
            </div>
          </form>
        </div>

        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-main" (click)="onSubmitAmountTopLoss()">
            {{(addChangeModeTopLoss) ? 'Add' : 'Reduce'}}
          </button>
        </div>

      </div>
    </div>
  </div>
</div>

